import { Component, OnInit, AfterViewInit, OnDestroy, Renderer2, HostListener } from '@angular/core';
declare var window:any;

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit, AfterViewInit, OnDestroy {

  alert: string = '';
  bannerHeight: number;

  constructor(private renderer: Renderer2) { }

  // Replaces $(window).on('load resize', ...)
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.adjustBannerHeight();
  }

  ngOnInit() {
    this.adjustBannerHeight();
  }

  adjustBannerHeight() {
    const banner = document.querySelector('.banner');
    if (banner) {
      const height = banner.getBoundingClientRect().height + 300;
      const positionBanner = document.querySelector('.position-ab-banner');
      if (positionBanner) {
        this.renderer.setStyle(positionBanner, 'height', `${height}px`);
      }
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // Move window.Intercom call here directly, no need for jQuery
      if (window.Intercom) {
        window.Intercom("boot", {
          app_id: "kgx05kdo",
        });
      }
    }, 3000);
  }

  ngOnDestroy() {
    if (window.Intercom) {
      window.Intercom("hide");
    }
  }
}
